import React from 'react'
import { Outlet } from 'react-router-dom'
import { CmsOrgProvider } from '../../model/CmsOrgContext'

export const CmsLayout: React.FC = () => {
    return (
        <CmsOrgProvider>
            <Outlet />
        </CmsOrgProvider>
    )
}
